interface IBudgetVehicleAndClientCardsProps {
  vehicleData?: {
    model?: string;
    year?: string;
    licensePlate?: string;
    chassis?: string;
    odometer?: string;
    hourmeter?: string;
    contract?: string;
    inWarranty?: boolean;
  };
  clientData?: {
    name?: string;
    phone?: string;
    email?: string;
  };
  isMobile?: boolean;
}

const BudgetVehicleAndClientCards = (props: IBudgetVehicleAndClientCardsProps) => {
  const isMobile = props.isMobile || false;
  const vehicle = props.vehicleData;
  const client = props.clientData;

  if (!vehicle && !client) {
    return null;
  }

  return (
    <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'} gap-4 mb-6 ${isMobile ? 'px-2' : 'px-6'} items-stretch`}>
      {vehicle && (
        <div className="flex-1 flex flex-col mr-3">
          <div className="font-semibold text-black dark:text-neutral-200 text-size-13 bg-white dark:bg-neutral-900 p-1 rounded-t-lg">Veículo</div>
          <div className="bg-[#E5EBF0] dark:bg-neutral-800 rounded-b-lg p-4 relative flex-1">
            <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'} items-start gap-4`}>
              <div className={`bg-white dark:bg-neutral-900 p-4 flex-shrink-0 ${isMobile ? 'w-[45px] h-[55px]' : 'w-[55px] h-[70px]'} flex items-center justify-center ${isMobile ? 'mb-2' : 'mr-2'}`}>
                <img
                  src="/assets/images/truck.svg"
                  alt="Veículo"
                  className="w-full h-full object-contain dark:invert"
                />
              </div>
              <div className="flex-1">
                {(vehicle.model || vehicle.year || vehicle.licensePlate) && (
                  <div className="font-300 text-[#344054] dark:text-neutral-300 text-size-15 leading-tight">
                    {vehicle.model && <span className="font-semibold text-[#43516a] dark:text-neutral-200 text-size-15">{vehicle.model}</span>}
                    {vehicle.year && <span className="font-300 text-[#43516a] dark:text-neutral-300 text-size-15"> {vehicle.year}</span>}
                    {vehicle.licensePlate && <span className="font-300 text-[#344054] dark:text-neutral-300 text-size-15"> | Placa: {vehicle.licensePlate}</span>}
                  </div>
                )}
                {vehicle.chassis && (
                  <div className="font-300 text-[#344054] dark:text-neutral-300 text-size-15 leading-tight">Chassi - {vehicle.chassis}</div>
                )}
                {(vehicle.odometer || vehicle.hourmeter) && (
                  <div className="font-300 text-[#344054] dark:text-neutral-300 text-size-15 leading-tight">
                    {vehicle.odometer && <span className="font-300 text-[#344054] dark:text-neutral-300 text-size-15">Odômetro: {vehicle.odometer}</span>}
                    {vehicle.odometer && vehicle.hourmeter && ' | '}
                    {vehicle.hourmeter && <span className="font-300 text-[#344054] dark:text-neutral-300 text-size-15">Horímetro: {vehicle.hourmeter}</span>}
                  </div>
                )}
                {vehicle.contract && (
                  <div className="text-size-14 leading-tight">
                    Volks total Prev: Contrato #{vehicle.contract}
                  </div>
                )}
              </div>
            </div>
            {vehicle.inWarranty === true && (
              <div className={`${isMobile ? 'relative top-0 right-0 mt-2' : 'absolute top-4 right-4 mt-3 mr-3'}`}>
                <span className="px-3 py-1 rounded-full text-size-12 bg-green-500 text-white font-bold">
                  Em garantia
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {client && (
        <div className="flex-1 flex flex-col">
          <div className="font-semibold text-black dark:text-neutral-200 text-size-13 bg-white dark:bg-neutral-900 p-1 rounded-t-lg">Cliente</div>
          <div className="bg-white dark:bg-neutral-900 border border-gray-300 dark:border-neutral-700 rounded-b-lg p-4 flex-1">
            {client.name && <div className="font-300 text-[#344054] dark:text-neutral-300 text-size-14 mb-1">{client.name}</div>}
            {client.phone && <div className="font-300 text-[#344054] dark:text-neutral-300 text-size-12 mb-1">{client.phone}</div>}
            {client.email && <div className={`font-300 text-[#344054] dark:text-neutral-300 text-size-12 ${isMobile ? '' : 'text-right'}`}>{client.email}</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default BudgetVehicleAndClientCards;
